import { ApiService } from "../services/api";

const PENDING_VIDEO_CREDIT_PREFIX = "zullu_pending_video_credits_";

const getPendingVideoCreditKey = (jobId) =>
  `${PENDING_VIDEO_CREDIT_PREFIX}${jobId}`;

export const rememberPendingVideoCredit = ({ jobId, userId, amount }) => {
  if (!jobId || !userId || !amount) return;

  localStorage.setItem(
    getPendingVideoCreditKey(jobId),
    JSON.stringify({
      userId,
      amount,
      createdAt: Date.now(),
    })
  );
};

export const settlePendingVideoCredit = async (jobId) => {
  if (!jobId) return false;

  const key = getPendingVideoCreditKey(jobId);
  const rawValue = localStorage.getItem(key);
  if (!rawValue) return false;

  try {
    const pendingCredit = JSON.parse(rawValue);
    const response = await ApiService.deductCreditsForIdentifier(
      pendingCredit.userId,
      pendingCredit.amount
    );

    if (response?.success || response?.status === "success") {
      localStorage.removeItem(key);
      window.dispatchEvent(new Event("zulluCreditsUpdated"));
      return true;
    }
  } catch (error) {
    console.error("Pending video credit settlement failed:", error);
  }

  return false;
};
